export default { sha: '236c8a68b87209f7d5f17bc173c8765419339f1a', buildNumber: 'undefined' }
